export const femaleNames = Array.from(
  new Set([
    "<3",
    "$$",
    "Ash",
    "Ava",
    "Emma",
    "Isabella",
    "Sophia",
    "Mia",
    "Charlotte",
    "Amelia",
    "Evelyn",
    "Abigail",
    "Harper",
    "Seraphina",
    "Aveline",
    "Evadne",
    "Isolde",
    "Thalassa",
    "Marigold",
    "Zephyra",
    "Calista",
    "Azura",
    "Elowen",
    "Cassiopeia",
    "Ondine",
    "Elysia",
    "Fiora",
    "Celestia",
    "Lyra",
    "Solene",
    "Veridian",
    "Amara",
    "Lysandra",
    "Cressida",
    "Seren",
    "Isolde",
    "Odalys",
    "Galatea",
    "Marcella",
    "Zephyrine",
    "Persephone",
    "Belphoebe",
    "Selene",
    "Aurora",
    "Elara",
    "Thalia",
    "Astraea",
    "Calliope",
    "Zenobia",
    "Amarante",
    "Eowyn",
    "Leocadia",
    "Selene",
    "Amaryllis",
    "Artemis",
    "Freesia",
    "Valencia",
    "Lirael",
    "Calypso",
    "Seraphine",
    "Solstice",
    "Isidora",
    "Evadne",
    "Nereida",
    "Ondine",
    "Isabeau",
    "Elsinore",
    "Elestria",
    "Melisande",
    "Thalassa",
    "Lysandra",
    "Marisabel",
    "Sapphira",
    "Odalys",
    "Arista",
    "Zenovia",
    "Callidora",
    "Elowen",
    "Seren",
    "Cressida",
    "Isolde",
    "Vespera",
    "Zephyra",
    "Melusine",
    "Belphoebe",
    "Celestia",
    "Calista",
    "Aveline",
    "Amara",
    "Azura",
    "Veridian",
    "Elysia",
    "Celandine",
    "Eowyn",
    "Persephone",
    "Elara",
    "Lyra",
    "Sylvestra",
    "Galatea",
    "Marigold",
    "Seraphina",
    "Thalia",
    "Isolde",
    "Zephyrine",
    "Marcella",
    "Odalys",
    "Amaryllis",
    "Solene",
    "Fiora",
    "Selene",
    "Amarante",
    "Eowyn",
    "Cressida",
    "Seren",
    "Isolde",
    "Leocadia",
    "Zenobia",
    "Lirael",
    "Freesia",
    "Valencia",
    "Artemis",
    "Calypso",
    "Elestria",
    "Selene",
    "Aurora",
    "Thalassa",
    "Seraphine",
    "Elowen",
    "Ondine",
    "Isidora",
    "Zenovia",
    "Evadne",
    "Nereida",
    "Marisabel",
    "Sapphira",
    "Lysandra",
    "Solstice",
    "Isabeau",
    "Odalys",
    "Melusine",
    "Arista",
    "Callidora",
    "Elestria",
    "Isolde",
    "Calista",
    "Zephyra",
    "Vespera",
    "Belphoebe",
    "Celestia",
    "Seren",
    "Aveline",
    "Amara",
    "Azura",
    "Elsinore",
    "Elysia",
    "Calliope",
    "Melisande",
    "Eowyn",
    "Elara",
    "Celandine",
    "Lyra",
    "Sylvestra",
    "Galatea",
    "Hannah",
    "Olivia",
    "Grace",
    "Lily",
    "Emily",
    "Sophie",
    "Ella",
    "Chloe",
    "Layla",
    "Zoe",
    "Lila",
    "Lucy",
    "Avery",
    "Ruby",
    "Leah",
    "Nora",
    "Maya",
    "Luna",
    "Zara",
    "Violet",
    "Stella",
    "Willow",
    "Savannah",
    "Penelope",
    "Madison",
    "Hazel",
    "Scarlett",
    "Aria",
    "Mila",
    "Nova",
    "Eleanor",
    "Hannah",
    "Aubrey",
    "Piper",
    "Zoey",
    "Camila",
    "Alice",
    "Haley",
    "Layla",
    "Sophie",
    "Mila",
    "Zara",
    "Nora",
    "Leah",
    "Chloe",
    "Ruby",
    "Lucy",
    "Avery",
    "Ella",
    "Maya",
    "Lila",
    "Emily",
    "Lily",
    "Olivia",
    "Grace",
    "Hazel",
    "Eleanor",
    "Aria",
    "Stella",
    "Nova",
    "Willow",
    "Savannah",
    "Scarlett",
    "Madison",
    "Aubrey",
    "Piper",
    "Zoey",
    "Camila",
    "Alice",
    "Haley",
  ])
);
